<div class="modal-header">
  <h4 class="modal-title pull-left">
    Confirmación
  </h4>
</div>
<div class="modal-body" [innerHtml]="content"></div>
<div class="modal-footer">
  <div class="row justify-content-end">
    <div class="col-12">
      <button type="button" class="btn btn-primary btn-block w-100" (click)="accept()">Sí</button>
    </div>
    <div class="col-12">
      <button type="button" class="btn btn-dark btn-block w-100" (click)="noAccept()">No</button>
    </div>
  </div>
</div>
